/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  DeleteAdminV1StoresStoreIdMarketsIdPathParameters,
  GetAdminV1OrgExchangeRates200,
  GetAdminV1StoresStoreIdMarkets200,
  GetAdminV1StoresStoreIdMarketsPathParameters,
  Market,
  PatchAdminV1StoresStoreIdMarketsIdBody,
  PatchAdminV1StoresStoreIdMarketsIdPathParameters,
  PostAdminV1StoresStoreIdMarketsBody,
  PostAdminV1StoresStoreIdMarketsPathParameters
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Markets of the store, default first
 */
export const getAdminV1StoresStoreIdMarkets = (
    { storeId }: GetAdminV1StoresStoreIdMarketsPathParameters,
 options?: SecondParameter<typeof customInstance<GetAdminV1StoresStoreIdMarkets200>>,) => {
      return customInstance<GetAdminV1StoresStoreIdMarkets200>(
      {url: `/admin/v1/stores/${storeId}/markets`, method: 'GET'
    },
      options);
    }
  /**
 * A country belongs to one market of the store; the price list, when given, must belong to the store. 422 EXCHANGE_RATE_MISSING on body.currency when the platform has no rate from the store currency: products would be unpriceable there
 * @summary Add a market
 */
export const postAdminV1StoresStoreIdMarkets = (
    { storeId }: PostAdminV1StoresStoreIdMarketsPathParameters,
    postAdminV1StoresStoreIdMarketsBody: BodyType<PostAdminV1StoresStoreIdMarketsBody>,
 options?: SecondParameter<typeof customInstance<Market>>,) => {
      return customInstance<Market>(
      {url: `/admin/v1/stores/${storeId}/markets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAdminV1StoresStoreIdMarketsBody
    },
      options);
    }
  /**
 * @summary Update a market or make it the default
 */
export const patchAdminV1StoresStoreIdMarketsId = (
    { storeId, id }: PatchAdminV1StoresStoreIdMarketsIdPathParameters,
    patchAdminV1StoresStoreIdMarketsIdBody: BodyType<PatchAdminV1StoresStoreIdMarketsIdBody>,
 options?: SecondParameter<typeof customInstance<Market>>,) => {
      return customInstance<Market>(
      {url: `/admin/v1/stores/${storeId}/markets/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchAdminV1StoresStoreIdMarketsIdBody
    },
      options);
    }
  /**
 * @summary Delete a market. The default market cannot be deleted
 */
export const deleteAdminV1StoresStoreIdMarketsId = (
    { storeId, id }: DeleteAdminV1StoresStoreIdMarketsIdPathParameters,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/admin/v1/stores/${storeId}/markets/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * Read-only for tenants: rates are set by the platform team. A market can only be created in a currency that has a rate from the store currency (either direction)
 * @summary Exchange rates the platform maintains, newest per pair
 */
export const getAdminV1OrgExchangeRates = (

 options?: SecondParameter<typeof customInstance<GetAdminV1OrgExchangeRates200>>,) => {
      return customInstance<GetAdminV1OrgExchangeRates200>(
      {url: `/admin/v1/org/exchange-rates`, method: 'GET'
    },
      options);
    }
  export type GetAdminV1StoresStoreIdMarketsResult = NonNullable<Awaited<ReturnType<typeof getAdminV1StoresStoreIdMarkets>>>
export type PostAdminV1StoresStoreIdMarketsResult = NonNullable<Awaited<ReturnType<typeof postAdminV1StoresStoreIdMarkets>>>
export type PatchAdminV1StoresStoreIdMarketsIdResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1StoresStoreIdMarketsId>>>
export type DeleteAdminV1StoresStoreIdMarketsIdResult = NonNullable<Awaited<ReturnType<typeof deleteAdminV1StoresStoreIdMarketsId>>>
export type GetAdminV1OrgExchangeRatesResult = NonNullable<Awaited<ReturnType<typeof getAdminV1OrgExchangeRates>>>
